/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import InsuranceClaimsidInsuranceClaim from './InsuranceClaimsidInsuranceClaim';

/**
 * The InsuranceClaimsIdBody model module.
 * @module model/InsuranceClaimsIdBody
 * @version v0.3
 */
export default class InsuranceClaimsIdBody {
  /**
   * Constructs a new <code>InsuranceClaimsIdBody</code>.
   * @alias module:model/InsuranceClaimsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InsuranceClaimsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsuranceClaimsIdBody} obj Optional instance to populate.
   * @return {module:model/InsuranceClaimsIdBody} The populated <code>InsuranceClaimsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InsuranceClaimsIdBody();
      if (data.hasOwnProperty('insurance_claim'))
        obj.insuranceClaim = InsuranceClaimsidInsuranceClaim.constructFromObject(data['insurance_claim']);
    }
    return obj;
  }
}

/**
 * @member {module:model/InsuranceClaimsidInsuranceClaim} insuranceClaim
 */
InsuranceClaimsIdBody.prototype.insuranceClaim = undefined;

